import actions from "./actions";

const {FETCH_HALF_YEARLY} = actions;
const initState = {
    halfYearly: [],
};

const HalfYearlyReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_HALF_YEARLY:
            return {
                ...state,
                halfYearly: data
            }
        default:
            return state;
    }
}

export default HalfYearlyReducer;
